'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CameraIcon = require('../CameraIcon');

var _CameraIcon2 = _interopRequireDefault(_CameraIcon);

var _SurfHeight = require('../SurfHeight');

var _SurfHeight2 = _interopRequireDefault(_SurfHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var containerClassName = function containerClassName(conditions, highlight) {
  var classObject = {};
  var transformedConditions = conditions.replace(/_/g, '-').toLowerCase();
  classObject['quiver-spot-marker__container'] = true;
  classObject['quiver-spot-marker__container--' + transformedConditions] = true;
  classObject['quiver-spot-marker__container--highlight'] = highlight;

  return (0, _classnames2.default)(classObject);
};

var SpotMarker = function SpotMarker(_ref) {
  var conditions = _ref.conditions,
      _ref$surf = _ref.surf,
      min = _ref$surf.min,
      max = _ref$surf.max,
      units = _ref$surf.units,
      hasCamera = _ref.hasCamera,
      highlight = _ref.highlight,
      style = _ref.style;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-spot-marker', style: style },
    _react2.default.createElement(
      'div',
      { className: containerClassName(conditions, highlight), style: style && style.container },
      _react2.default.createElement(
        'div',
        { className: 'quiver-spot-marker__main', style: style && style.main },
        _react2.default.createElement(
          'div',
          { className: 'quiver-spot-marker__surf', style: style && style.surf },
          _react2.default.createElement(_SurfHeight2.default, { min: min, max: max, units: units })
        ),
        hasCamera ? _react2.default.createElement(
          'div',
          { className: 'quiver-spot-marker__camera', style: style && style.camera },
          _react2.default.createElement(_CameraIcon2.default, null)
        ) : null
      )
    )
  );
};

SpotMarker.propTypes = {
  surf: _propTypes2.default.shape({
    min: _propTypes2.default.number,
    max: _propTypes2.default.number,
    units: _propTypes2.default.string
  }).isRequired,
  conditions: _propTypes2.default.string,
  hasCamera: _propTypes2.default.bool,
  highlight: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

SpotMarker.defaultProps = {
  conditions: 'LOLA'
};

exports.default = SpotMarker;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotMarker/SpotMarker.js
// module id = 653
// module chunks = 11